export default function SuspendedTenant() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg)',
        fontFamily: 'var(--font-body)',
      }}
    >
      <div style={{ textAlign: 'center', padding: '0 24px', maxWidth: 480 }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: 'linear-gradient(135deg, #fb7185, #f43f5e)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 28,
            fontWeight: 800,
            color: '#fff',
            fontFamily: 'var(--font-display)',
            margin: '0 auto 24px',
          }}
        >
          !
        </div>
        <div
          className="display"
          style={{ fontSize: 32, fontWeight: 700, color: 'var(--fg)', marginBottom: 12 }}
        >
          Account Suspended
        </div>
        <div style={{ fontSize: 15, color: 'var(--fg2)', lineHeight: 1.6, marginBottom: 32 }}>
          We apologize for the inconvenience, but this workspace has been suspended.
        </div>
        <div
          style={{
            padding: '16px 20px',
            borderRadius: 12,
            background: 'var(--bg2)',
            border: '1px solid var(--border)',
            fontSize: 13,
            color: 'var(--fg3)',
            lineHeight: 1.8,
          }}
        >
          Please contact your Customer Success Manager to regain access to your workspace.
        </div>
        <div style={{ marginTop: 16, fontSize: 11, color: 'var(--fg3)' }}>
          Need help? Reach out to{' '}
          <span style={{ color: 'var(--accent)', fontWeight: 600 }}>hello@tryggr.dk</span>
        </div>
      </div>
    </div>
  );
}
